export const GET_SEJOURS_EVENTS = "sejours/GET_SEJOURS_EVENTS";
export const UPDATE_SEJOURS_EVENTS = "sejours/UPDATE_SEJOURS_EVENTS";
export const DELETE_SEJOURS_EVENTS = "sejours/DELETE_SEJOURS_EVENTS";